import { CurrencyIcon, HStack, Stack, Text, useCurrenciesContext } from '@talos/kyoko';
import { memo } from 'react';
import { useTheme } from 'styled-components';
import { useDealProductBuilder } from './DealProductBuilderProvider/useDealProductBuilder';
import { getProductDisplayName } from './productConfig';

interface DealProductBuilderDetailsProps {
  panelID: string;
}

export const DealProductBuilderDetails = memo(({ panelID }: DealProductBuilderDetailsProps) => {
  const theme = useTheme();
  const { state } = useDealProductBuilder();
  // At present, all products have a single row, but this will be updated to support multiple rows in the future
  const positionRow = state.rowData.at(0);
  const { currenciesBySymbol } = useCurrenciesContext();

  const title = positionRow?.productTemplate
    ? positionRow.uniqueSuffix
      ? `${positionRow.productTemplate}-${positionRow.uniqueSuffix}`
      : positionRow.productTemplate
    : 'Complete Product Details';
  const subTitle = positionRow?.productTemplate ? getProductDisplayName(positionRow.product) : '---';
  const currency = positionRow?.productTemplate ? currenciesBySymbol.get(positionRow.baseAsset ?? '') : undefined;
  return (
    <HStack gap="spacing8">
      <CurrencyIcon currency={currency?.Symbol} size={32} style={ICON_STYLE} theme={theme} />
      <Stack gap="spacing2">
        <Text color="colors.gray.100" fontSize="fontSizeMd">
          {title}
        </Text>
        <Text color="colors.gray.090" fontSize="fontSizeSm">
          {subTitle}
        </Text>
      </Stack>
    </HStack>
  );
});

const ICON_STYLE = {
  flexShrink: 0,
};
